import { ReactNode, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/auth';

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, fetchUser } = useAuthStore();
  const token = localStorage.getItem('access_token');

  // If we have a token but the store hasn't rehydrated yet, fetch the user
  // to restore the auth state. The API client's 401 interceptor handles
  // invalid tokens (redirects to /login).
  useEffect(() => {
    if (token && !isAuthenticated) {
      fetchUser();
    }
  }, [token, isAuthenticated, fetchUser]);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Render children immediately if token exists; fetchUser runs in background
  // to restore the full user profile. If the token is invalid, the 401
  // interceptor will redirect to /login.
  return <>{children}</>;
}